import * as Yup from 'yup';

export const startupCrudFormSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    founder_first_name: Yup.string().required('Required'),
    founder_last_name: Yup.string().required('Required'),
    founder_email: Yup.string().email('Please enter a valid email').required('Required'),
    mobile_number: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    business_description: Yup.string().required('Required'),

    industry: Yup.string().required('Required'),
    stage: Yup.string().required('Required'),
    sector: Yup.array().min(1, "at least 1 sector is required").required("required"),
    segment: Yup.string().required('Required'),
    current_status: Yup.string().required('Required'),
    active: Yup.string().required('Required'),
    ask_amount: Yup.number("This should be a number").required('Required'),
    lead_source: Yup.string().required('Required'),
    relationship_manager: Yup.string().required('Required'),
});